var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0817 13.6561C24.0518 15.7659 27.924 19.7627 27.924 24.3425C27.924 28.9223 23.9272 32.1842 19.0001 32.1842C14.073 32.1842 10.0898 28.9785 10.0898 24.3425C10.0898 19.7065 13.9484 15.7651 16.9184 13.6561L13.7682 9.28461C13.4779 8.68117 13.6064 7.95993 14.0874 7.49405C14.5457 7.01601 15.2784 6.92937 15.8362 7.28581C16.3788 7.59513 17.0674 7.44541 17.4322 6.93849L17.7377 6.52201C18.0166 6.09261 18.4886 5.82737 19.0008 5.81445C19.5062 5.81521 19.9805 6.05765 20.2776 6.46653L20.5832 6.88301C20.948 7.38993 21.6365 7.53965 22.1792 7.23033C22.737 6.87389 23.4696 6.96053 23.9279 7.43857C24.4386 7.91205 24.5648 8.67129 24.2334 9.28461L21.0832 13.6561H21.0817Z",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1421 13.4482H23.8579",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59086 30.103C5.52502 30.103 3.03906 27.6178 3.03906 24.5512C3.16142 21.1373 4.98542 18.0114 7.89698 16.2239L6.17634 13.212C5.97494 12.8944 5.97494 12.4885 6.17634 12.1708C6.40358 11.8638 6.78586 11.7126 7.16206 11.7825C8.07786 11.9672 9.02178 11.9672 9.93758 11.7825C10.313 11.7133 10.6961 11.8638 10.9233 12.1708C11.1247 12.4885 11.1247 12.8944 10.9233 13.212L9.2855 16.2239",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81543 16.2246H9.28483",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4088 30.103C32.4746 30.103 34.9606 27.6178 34.9606 24.5512C34.8382 21.1373 33.0142 18.0114 30.1027 16.2239L31.8233 13.212C32.0247 12.8944 32.0247 12.4885 31.8233 12.1708C31.5961 11.8638 31.2138 11.7126 30.8376 11.7825C29.9218 11.9672 28.9779 11.9672 28.0621 11.7825C27.6866 11.7133 27.3036 11.8638 27.0763 12.1708C26.8749 12.4885 26.8749 12.8944 27.0763 13.212L28.7141 16.2239",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1842 16.2246H28.7148",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/rewards.6322b8dabbaa88eb96565671bac0ec14.svg";
export { ForwardRef as ReactComponent };